import { APIModel } from "../../api-model";
import { AssociatedUser } from "../../associated-user";
import { Template } from "./template";
import { AppliedItem } from './applied-item';

export class AppliedTemplate extends APIModel {
  id: string;
  checklist_template_id: string;
  status: string;
  match_id: string;
  template_id: string;
  checklist_template: Template;
  applied_items: AppliedItem[];
  reference_link: string;

  checklist_application_id!: string;

  static fieldsToMap = {
    direct: [
      'id',
      'checklist_template_id',
      'template_id',
      'checklist_application_id',
      'status',
      'match_id',
      'reference_link',
      'template_name',
      'notes'
    ]
  }

  static buildFromAPI(record: any): AppliedTemplate {
    const row = new AppliedTemplate();
    record = record || {};

    this.mapFieldsDirectly<AppliedTemplate>(AppliedTemplate.fieldsToMap.direct, record, row);
    row.applied_items = [];
    if(record.applied_items) {
      record.applied_items.forEach((ai: any) => {
        row.applied_items.push(AppliedItem.buildFromAPI(ai, record));
      })
    }

    row.checklist_template = Template.buildFromAPI(record.template);
    
    return row
  }
}